export default __webpack_public_path__ + "static/media/ic_en_flag.47706986.svg";